import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { CardLinkAnalyticsService } from 'src/app/service/card-link-analytics.service';
import { UtilityService } from 'src/app/service/utility.service';

@Component({
  selector: 'app-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.scss'],
})
export class ContactInfoComponent implements OnChanges {
  @Input() cardDetails: any;
  @Input() dir: string = '';
  @Input() Lang: string = '';
  @Input() primaryThemeType: string = 'solid';
  @Input() primaryThemeColor: string = '#000000';
  @Input() primaryGradientColor: Record<string, string> = {};
  @Input() secondaryThemeColor: string = '#000000';
  @Input() secondaryThemeStyle: Record<string, any> = {};
  @Input() primaryTextColor: string = '#000000';
  @Input() secondaryTextColor: string = '#666666';
  @Input() cardNo: string = '';

  addressValue: boolean = false;

  constructor(
    public utilService: UtilityService,
    private cardLinkAnalytics: CardLinkAnalyticsService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    const themeKeys = [
      'primaryThemeType',
      'primaryThemeColor',
      'primaryGradientColor',
    ];
    const themeChanged = themeKeys.some((k) => changes[k]);
    if (themeChanged) {
      this.cdr.detectChanges();
    }
  }

  get addressesForCurrentLang(): any[] {
    const lang = this.Lang;
    return (this.cardDetails?.general?.address || []).filter(
      (a: any) => !lang || a?.language === lang,
    );
  }

  get hasAnyAddress(): boolean {
    return this.addressesForCurrentLang.some(
      (a) => this.renderAddress(a).trim() !== '',
    );
  }

  contactLabelConversion(key: string, custom: boolean): string {
    if (!key || typeof key !== 'string') {
      return '';
    }
    if (key && key !== 'None') {
      if (custom) {
        return key;
      } else {
        return this.utilService.contactLabelConversion(
          key.toLowerCase(),
          this.Lang,
        );
      }
    }
    return '';
  }

  renderAddress(objAddress: any) {
    let address = this.utilService.renderAddress(objAddress);
    if (address != '') {
      this.addressValue = true;
    }
    if (this.dir == 'rtl') {
      return address = address.replace(/,/g, '،');
    }
    return (address);
  }

  getGradientId(key: string, index?: number): string {
    return index !== undefined ? `${key}Gradient-${index}` : `${key}Gradient`;
  }

  trackLinkClick(linkType: string, href: string, linkItem?: string): void {
    this.cardLinkAnalytics.trackLinkClick(this.cardNo, linkType, href, linkItem);
  }
}

